module.exports = __webpack_public_path__ + "img/013.fdd8db50.png";